import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const DiscountBadge = styled.div<{size: 'small' | 'medium' | 'large'}>(
  ({theme, size}) => css`
    border-radius: 20px;
    color: ${theme.colors.contentInversePrimary};
    background: ${theme.colors.contentAdditionalA};
    white-space: nowrap;
    ${size === 'medium' &&
    css`
      ${theme.typography.paragraphXSmallBold};
      padding: 2px 4px;
    `};
    ${size === 'large' &&
    css`
      ${theme.typography.labelSmallBold};
      padding: 0 4px;
    `};
  `
);
